export interface WorkerCounts {
    desiredWorkerCount: number,
    maxWorkerCount: number,
}

export enum UpdateWorkerCountAction {
    Reset = 0,
    Increment = 1,
    Decrement = 2,
}